import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, ChevronRight } from "lucide-react";
import { PageHeader, EmptyState } from "@/components/common";
import { StatusPill } from "@/components/StatusPill";
import { api } from "@/lib/api";
import { fmtTemp, elapsed } from "@/lib/format";

export default function Incidencias() {
  const [incidents, setIncidents] = useState([]);
  const [filter, setFilter] = useState("ALL");
  const nav = useNavigate();

  useEffect(() => {
    const q = filter === "ALL" ? "" : `?status=${filter}`;
    api.get(`/incidents${q}`).then(({ data }) => setIncidents(data)).catch(() => setIncidents([]));
  }, [filter]);

  const filters = [["ALL", "Todas"], ["OPEN", "Abiertas"], ["WAITING_RECHECK", "Esperando 2ª med."], ["RESOLVED", "Resueltas"], ["REOPENED", "Reabiertas"]];

  return (
    <div>
      <PageHeader title="Incidencias" subtitle="Lecturas fuera de rango y su resolución" />
      <div className="mb-4 flex flex-wrap gap-2">
        {filters.map(([v, l]) => (
          <button key={v} data-testid={`inc-filter-${v}`} onClick={() => setFilter(v)}
            className={`rounded-full px-3 py-1.5 text-sm font-medium ${filter === v ? "bg-primary text-primary-foreground" : "bg-white text-slate-600 border border-slate-200"}`}>{l}</button>
        ))}
      </div>
      {incidents.length === 0 ? (
        <EmptyState icon={AlertTriangle} title="Sin incidencias" subtitle="No hay incidencias en esta vista." />
      ) : (
        <div className="space-y-3">
          {incidents.map((i) => (
            <button key={i.id} data-testid={`incident-${i.id}`} onClick={() => nav(`/admin/incidencias/${i.id}`)}
              className="flex w-full items-center gap-3 rounded-2xl border border-slate-200 bg-white p-4 text-left hover:shadow-sm">
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <StatusPill status={i.status} />
                  <StatusPill status={i.severity} />
                </div>
                <p className="mt-1.5 font-medium">{i.equipment_name}</p>
                <p className="text-xs text-slate-500">{i.location_name} · {elapsed(i.opened_at)}</p>
              </div>
              <ChevronRight className="h-5 w-5 text-slate-300" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
